import script from "./ServicePriceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicePriceModal.vue?vue&type=script&setup=true&lang=js"

import "./ServicePriceModal.vue?vue&type=style&index=0&id=ca7a10da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca7a10da"]])

export default __exports__